import React from 'react'
import { Badge } from 'react-bootstrap'
import './AppCard.scss'

interface AppCardHeaderProps {
  name: string
  imageUrl?: string | null
  showPrivateBadge: boolean
}

export const AppCardHeader: React.FC<AppCardHeaderProps> = ({ name, imageUrl, showPrivateBadge }) => {
  const initials = name.slice(0, 2).toUpperCase() || '?'

  return (
    <div className='d-flex align-items-center justify-content-between'>
      <div className='app-card-icon'>
        {imageUrl ? <img src={imageUrl} alt={`${name} logo`} className='w-100 h-100' /> : <span className='app-icon-initials'>{initials}</span>}
      </div>
      {showPrivateBadge ? (
        <Badge bg='' className='app-card-private-badge'>
          <i className='bi bi-lock me-1' />
          Private
        </Badge>
      ) : null}
    </div>
  )
}
